import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section id="hero" className="w-full bg-cream px-5 py-10 md:py-16" aria-labelledby="hero-heading" data-id="element-113">
      <div className="mx-auto max-w-container" data-id="element-114">
        <p className="label-caps mb-4 text-center text-[12px] text-rose" data-id="element-115">
          Para mujeres de 45 a 60 años
        </p>

        <h1 id="hero-heading" className="font-serif text-center text-[28px] font-medium leading-[1.15] text-wine md:text-[36px]" data-id="element-116">
          El método de 21 días que está ayudando a miles de mujeres a vivir la
          menopausia{' '}
          <em className="font-serif italic font-medium text-burgundy" data-id="element-117">
            [sin sofocos, sin insomnio y sin medicamentos]
          </em>
        </h1>

        <p className="mt-5 text-center text-[17px] text-burgundy md:px-6" data-id="element-118">
          Sin dietas extremas. Sin terapia hormonal. Sin gastar fortunas en
          suplementos que no funcionan.
        </p>

        {/* Ebook mockup — real book style with depth & spine */}
        <div className="mt-10 flex justify-center" style={{
        perspective: '1400px'
      }} data-id="element-119">
          <div className="relative" style={{
          width: 280,
          height: 400,
          transformStyle: 'preserve-3d',
          transform: 'rotateY(-18deg) rotateX(2deg)'
        }} aria-label="Portada del ebook Menopausia en Equilibrio" data-id="element-120">
            {/* Page edges (right side of the book) */}
            <div aria-hidden="true" className="absolute top-0 right-0 h-full" style={{
            width: 14,
            transform: 'rotateY(90deg) translateZ(133px) translateX(7px)',
            background: 'repeating-linear-gradient(to bottom, #fdfaf4 0px, #fdfaf4 1px, #e8dcc8 1px, #e8dcc8 2px)',
            boxShadow: 'inset 0 0 6px rgba(0,0,0,0.2)'
          }} data-id="element-121" />

            {/* Back cover (depth) */}
            <div aria-hidden="true" className="absolute inset-0 rounded-r-[2px] rounded-l-[6px]" style={{
            transform: 'translateZ(-14px)',
            background: '#2a0b16'
          }} data-id="element-122" />

            {/* Front cover */}
            <div className="absolute inset-0 flex flex-col items-center justify-between overflow-hidden rounded-r-[2px] rounded-l-[6px] p-6 text-center" style={{
            background: 'linear-gradient(155deg, #72243E 0%, #4B1528 55%, #2e0b18 100%)',
            boxShadow: '30px 30px 60px -20px rgba(75, 21, 40, 0.45), 0 10px 30px rgba(0,0,0,0.18)'
          }} data-id="element-123">
              {/* Spine highlight (inner left edge) */}
              <div aria-hidden="true" className="absolute left-0 top-0 h-full" style={{
              width: 18,
              background: 'linear-gradient(to right, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.15) 50%, rgba(255,255,255,0.05) 100%)'
            }} data-id="element-124" />

              {/* Subtle gloss across cover */}
              <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
              background: 'linear-gradient(115deg, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0) 35%, rgba(255,255,255,0) 70%, rgba(255,255,255,0.06) 100%)'
            }} data-id="element-125" />

              {/* Decorative top border */}
              <div className="relative z-10 w-full" data-id="element-126">
                <div className="mx-auto h-px w-16 bg-pinkLight/50" data-id="element-127" />
                <p className="label-caps mt-3 text-[10px] text-pinkLight" data-id="element-128">
                  Vitalízate Ahora
                </p>
                <p className="mt-1 font-serif italic text-[10px] text-pinkLight/80" data-id="element-129">
                  Guía digital · 80 páginas
                </p>
              </div>

              {/* Title block */}
              <div className="relative z-10 px-2" data-id="element-130">
                <h2 className="font-serif italic text-[30px] font-medium leading-[1.05] text-cream" data-id="element-131">
                  Menopausia
                  <br data-id="element-132" />
                  en Equilibrio
                </h2>
                <div className="mx-auto mt-4 flex items-center justify-center gap-2" data-id="element-133">
                  <span className="h-px w-6 bg-pinkMed/70" data-id="element-134" />
                  <span className="text-[10px] text-pinkLight" data-id="element-135">♥</span>
                  <span className="h-px w-6 bg-pinkMed/70" data-id="element-136" />
                </div>
                <p className="mt-4 font-serif italic text-[12px] leading-relaxed text-cream/85" data-id="element-137">
                  El método de 21 días
                  <br data-id="element-138" />
                  para recuperar tu energía
                </p>
              </div>

              {/* Bottom branding */}
              <div className="relative z-10 w-full" data-id="element-139">
                <div className="mx-auto h-px w-16 bg-pinkLight/50" data-id="element-140" />
                <p className="label-caps mt-3 text-[9px] text-pinkLight/80" data-id="element-141">
                  Vitalízate Ahora
                </p>
              </div>
            </div>

            {/* Ground shadow */}
            <div aria-hidden="true" className="absolute -bottom-6 left-1/2 -translate-x-1/2" style={{
            width: 240,
            height: 24,
            background: 'radial-gradient(ellipse at center, rgba(75,21,40,0.35) 0%, rgba(75,21,40,0) 70%)',
            filter: 'blur(4px)'
          }} data-id="element-142" />
          </div>
        </div>

        {/* CTA */}
        <div className="mt-8 flex flex-col items-center" data-id="element-143">
          <CTAButton className="w-full max-w-md" data-id="element-144">
            Quiero mi guía ahora · $10
          </CTAButton>

          <p className="mt-3 text-[14px] text-rose" data-id="element-145">
            <span className="text-burgundy line-through" data-id="element-146">$27</span>{' '}
            <span className="mx-1" data-id="element-147">·</span>
            <span className="font-semibold text-rose" data-id="element-148">$10</span>{' '}
            <span className="text-burgundy" data-id="element-149">· Pago único</span>
          </p>

          <div className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[12px] text-burgundy" data-id="element-150">
            <span className="flex items-center gap-1" data-id="element-151">
              <CheckIcon size={14} className="text-success" data-id="element-152" /> Descarga
              inmediata
            </span>
            <span className="flex items-center gap-1" data-id="element-153">
              <CheckIcon size={14} className="text-success" data-id="element-154" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1" data-id="element-155">
              <CheckIcon size={14} className="text-success" data-id="element-156" /> Pago seguro
            </span>
          </div>
        </div>
      </div>
    </section>;
}